import { css } from "emotion";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment-timezone";
import { FormControlLabel } from "@material-ui/core";
import SwitchButton from "../../../components/Switch";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import TimePicker from "../../../components/InputDateTime/TimePicker";
import { v4 as uuidv4 } from "uuid";
import { QueryClient, useMutation } from "react-query";
import TenantService from "../../../Services/TenantService/TenantService";
import { handleError } from "../../../components/Utils/Utils";

const OperationalTimeForm = (props) => {
  const { openModal, handleToggle, operationalDays, tenant } = props;
  const [didMount, setDidMount] = React.useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });
  const allFields = watch();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "days",
    }
  );

  const queryClient = new QueryClient();

  const mutationOperationalHours = useMutation(
    (params) => TenantService.postOperationalHours(params),
    {
      onMutate: () => {
        queryClient.cancelQueries("getTenantOperationalHours");
      },
      onError: (error, variables, context) => {
        handleError(error.toString());
      },
      onSuccess: (data, error, variables, context) => {
        handleToggle();
      },
    }
  );

  const createFormatTime = (date) => {
    return moment.tz(date, tenant?.property?.timezone || "UTC").format("HH:mm");
  };

  const createFormatDateTime = (time) => {
    let today = moment.tz(tenant?.property?.timezone);
    let selectedTime =
      today.format("YYYY") +
      "-" +
      today.format("MM") +
      "-" +
      today.format("DD") +
      " " +
      time +
      ":00";
    let dateTime = moment.tz(selectedTime, tenant?.property?.timezone || "UTC");
    return dateTime.utc().format();
  };

  const compareTime = (time1, time2, allowEqual) => {
    let split1 = time1.split(":");
    let split2 = time2.split(":");

    const totalSecond1 = parseInt(split1[0]) * 3600 + parseInt(split1[1]) * 60;
    const totalSecond2 = parseInt(split2[0]) * 3600 + parseInt(split2[1]) * 60;

    return allowEqual
      ? totalSecond1 <= totalSecond2
      : totalSecond1 < totalSecond2;
  };

  const checkTime = (index, idxSlot, type, time) => {
    if (idxSlot === 0 && type === "open_time") {
      return true;
    } else {
      let days = allFields["days"];
      if (idxSlot === 0) {
        if (type === "close_time") {
          return compareTime(
            days[index]?.slots[0]["open_time"],
            days[index]?.slots[0]["close_time"],
            false
          );
        } else if (type === "last_order") {
          return compareTime(
            days[index]?.slots[0]["last_order"],
            days[index]?.slots[0]["close_time"],
            true
          );
        }
      } else {
        if (type === "open_time") {
          return compareTime(
            days[index]?.slots[idxSlot - 1]["close_time"],
            days[index]?.slots[idxSlot]["open_time"],
            false
          );
        } else if (type === "close_time") {
          return compareTime(
            days[index]?.slots[idxSlot]["open_time"],
            days[index]?.slots[idxSlot]["close_time"],
            false
          );
        } else if (type === "last_order") {
          return compareTime(
            days[index]?.slots[idxSlot]["last_order"],
            days[index]?.slots[idxSlot]["close_time"],
            true
          );
        }
      }
    }
  };

  const handleChangeOpenSt = (event, day) => {
    let days = allFields["days"];
    const findIndex = days?.findIndex((val) => val?.day === day);

    if (findIndex > -1) {
      days[findIndex]["open_st"] = event.target.checked;
      if (event.target.checked) {
        if (days[findIndex]["slots"].length === 0) {
          days[findIndex]["slots"] = [
            {
              day: day,
              open_st: true,
              open_time: "",
              close_time: "",
              last_order: "",
            },
          ];
        }
      } else {
        if (days[findIndex]["slots"].length > 0) {
          const slots = days[findIndex]["slots"];
          days[findIndex]["slots"] = slots?.map((val) => ({
            ...val,
            open_st: false,
          }));
        }
      }

      reset({ days });
    }
  };

  const handleChangeTime = (day, slot, type, time) => {
    // console.log(day + " day");
    // console.log(slot + " slot");
    // console.log(type + " type");
    // console.log(time + " time");
    // console.log(toLocaleString(time));

    let days = allFields["days"];
    // console.log(days);
    const findIndex = days?.findIndex((val) => val?.day === day);
    // console.log(findIndex);

    let today = new Date();
    // console.log(today, "ini curernt date");
    let selectedTime =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate() +
      " " +
      time +
      ":00";
    // let dateParse = new Date(Date.parse(selectedTime));
    let dateParse = moment(selectedTime, "YYYY-M-D HH:mm:ss").toDate();

    var a = dateParse
      .toLocaleString("en-US", {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timeZoneName: "short",
      })
      .split(/GMT/g)[1];

    // console.log(a, " aaaa");

    var b = dateParse
      .toLocaleString("en-US", {
        timeZone: tenant?.property?.timezone,
        timeZoneName: "short",
      })
      .split(/GMT/g)[1];

    // console.log(b, " bbb");
    var diff = a - b;
    // console.log(diff, " a-b");
    if (diff > 0) {
      dateParse.setHours(dateParse.getHours() + Math.abs(diff));
      // console.log(" masuk > 0");
    } else if (diff < 0) {
      // console.log(" masuk < 0");
      dateParse.setHours(dateParse.getHours() - Math.abs(diff));
    }
    // console.log(" masuk = 0");

    if (findIndex > -1) {
      if (
        days[findIndex]["slots"].length > 0 &&
        days[findIndex]["slots"][slot]
      ) {
        days[findIndex]["slots"][slot][type] = createFormatTime(dateParse);

        if (type === "close_time") {
          days[findIndex]["slots"][slot]["last_order"] =
            createFormatTime(dateParse);
        }

        reset({ days });
      }
    }
  };

  const handleAddSlot = (day) => {
    let days = allFields["days"];
    const findIndex = days?.findIndex((val) => val?.day === day);

    if (findIndex > -1) {
      let slots = days[findIndex]["slots"];
      slots.push({
        day: day,
        key_slot: uuidv4(),
        open_st: true,
        open_time: "",
        close_time: "",
        last_order: "",
      });

      days[findIndex]["slots"] = slots;

      reset({
        days,
      });
    }
  };

  const handleRemoveSlot = (index, idxSlot) => {
    let days = allFields["days"];
    let slots = days[index]["slots"];

    slots.splice(idxSlot, 1);
    days[index]["slots"] = slots;

    reset({
      days,
    });
  };

  const onSubmit = (data) => {
    const remap = data?.days?.map((days) => ({
      ...days,
      slots: days?.slots?.map((slot) => ({
        ...slot,
        key_slot: uuidv4(),
        open_time: createFormatDateTime(slot?.open_time),
        close_time: createFormatDateTime(slot?.close_time),
        last_order: createFormatDateTime(slot?.last_order),
      })),
    }));

    mutationOperationalHours.mutate(remap);
  };

  const handleClickClose = () => {
    const remap = operationalDays?.map((days) => ({
      ...days,
      slots: days?.slots?.map((slot) => ({
        ...slot,
        key_slot: uuidv4(),
        open_time: createFormatTime(slot?.open_time),
        close_time: createFormatTime(slot?.close_time),
        last_order: createFormatTime(slot?.last_order),
      })),
    }));
    reset({
      days: remap,
    });
    handleToggle();
  };

  React.useEffect(() => {
    if (!didMount) {
      const remap = operationalDays?.map((days) => ({
        ...days,
        slots: days?.slots?.map((slot) => ({
          ...slot,
          key_slot: uuidv4(),
          open_time: createFormatTime(slot?.open_time),
          close_time: createFormatTime(slot?.close_time),
          last_order: createFormatTime(slot?.last_order),
        })),
      }));
      reset({
        days: remap,
      });
      setDidMount(true);
    }
  }, []);

  return (
    <Modal
      isOpen={openModal}
      toggle={handleToggle}
      backdrop={false}
      size="lg"
      centered={true}
      zIndex={1300}
      modalClassName={css`
        max-height: 100%;
        overflow-y: scroll !important;
        background: rgba(0, 0, 0, 0.5);
      `}
      contentClassName={css`
        background: none !important;
        border: none !important;
      `}
    >
      <ModalBody>
        <div className="row">
          <div className="col-12">
            <div className="card rounded-8px mb-3 p-3">
              <p className="font-12 text-center mb-0">
                Jika tidak ditentukan, Jam <i>Last Order</i> akan terisi sesuai
                jam tutup.
              </p>
            </div>
            <div className="card rounded-8px p-4">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <p className="font-bold font-16 mb-0">Atur jam operasional</p>
                <span
                  className="font-20 text-primary"
                  onClick={() => handleClickClose()}
                >
                  <CloseIcon />
                </span>
              </div>
              {allFields?.days?.length > 0 && (
                <div className="table-responsive">
                  <table className="table table-no-border">
                    <thead>
                      <tr>
                        <th width="15%"></th>
                        <th width="20%"></th>
                        <th className="text-primary font-bold" width="15%">
                          Jam Buka
                        </th>
                        <th className="text-primary font-bold" width="15%">
                          Jam Tutup
                        </th>
                        <th className="text-primary font-bold" width="20%">
                          Jam Last Order
                        </th>
                        <th width="15%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {fields?.map((day, index) => (
                        <React.Fragment key={index}>
                          <tr key={index + "-0"}>
                            <td className="font-bold text-capitalize">
                              {day?.day}
                            </td>
                            <td className="font-bold text-capitalize">
                              <div className="form-group d-flex justify-content-center align-items-center">
                                <FormControlLabel
                                  control={
                                    <SwitchButton
                                      checked={day?.open_st}
                                      onChange={(event) => {
                                        handleChangeOpenSt(event, day?.day);
                                      }}
                                      name="checked"
                                      size="small"
                                    />
                                  }
                                />
                                <label className="font-12 ml-2 font-normal">
                                  {day?.open_st ? "Buka" : "Tutup"}
                                </label>
                              </div>
                            </td>
                            <td>
                              {day?.open_st && (
                                <React.Fragment>
                                  <Controller
                                    name={`days[${index}].slots[0].open_time`}
                                    control={control}
                                    rules={{
                                      required: "Input jam buka",
                                    }}
                                    render={({ field }) => (
                                      <TimePicker
                                        {...field}
                                        timeValue={
                                          allFields["days"][index]["slots"]
                                            .length > 0
                                            ? allFields["days"][index][
                                                "slots"
                                              ][0]["open_time"]
                                            : ""
                                        }
                                        handleChange={(e) => {
                                          // console.log(e.target.value);
                                          handleChangeTime(
                                            day?.day,
                                            0,
                                            "open_time",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      allFields["days"][index]["slots"].length >
                                      0
                                        ? allFields["days"][index]["slots"][0][
                                            "open_time"
                                          ]
                                        : ""
                                    }
                                  />
                                  {errors &&
                                    errors?.days &&
                                    errors?.days[index] &&
                                    errors?.days[index].slots[0] &&
                                    errors?.days[index].slots[0].open_time && (
                                      <span className="d-block font-12 text-danger">
                                        {
                                          errors?.days[index].slots[0].open_time
                                            ?.message
                                        }
                                      </span>
                                    )}
                                </React.Fragment>
                              )}
                            </td>
                            <td>
                              {day?.open_st && (
                                <React.Fragment>
                                  <Controller
                                    name={`days[${index}].slots[0].close_time`}
                                    control={control}
                                    rules={{
                                      required: "Input jam tutup",
                                      validate: (close_time) => {
                                        if (
                                          !checkTime(
                                            index,
                                            0,
                                            "close_time",
                                            close_time
                                          )
                                        ) {
                                          return "Periksa kembali";
                                        }
                                        return true;
                                      },
                                    }}
                                    render={({ field }) => (
                                      <TimePicker
                                        {...field}
                                        timeValue={
                                          allFields["days"][index]["slots"]
                                            .length > 0
                                            ? allFields["days"][index][
                                                "slots"
                                              ][0]["close_time"]
                                            : ""
                                        }
                                        handleChange={(e) => {
                                          handleChangeTime(
                                            day?.day,
                                            0,
                                            "close_time",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      allFields["days"][index]["slots"].length >
                                      0
                                        ? allFields["days"][index]["slots"][0][
                                            "close_time"
                                          ]
                                        : ""
                                    }
                                  />
                                  {errors &&
                                    errors?.days &&
                                    errors?.days[index] &&
                                    errors?.days[index].slots[0] &&
                                    errors?.days[index].slots[0].close_time && (
                                      <span className="d-block font-12 text-danger">
                                        {
                                          errors?.days[index].slots[0]
                                            .close_time?.message
                                        }
                                      </span>
                                    )}
                                </React.Fragment>
                              )}
                            </td>
                            <td>
                              {day?.open_st && (
                                <React.Fragment>
                                  <Controller
                                    name={`days[${index}].slots[0].last_order`}
                                    control={control}
                                    rules={{
                                      validate: (last_order) => {
                                        if (
                                          !checkTime(
                                            index,
                                            0,
                                            "last_order",
                                            last_order
                                          )
                                        ) {
                                          return "Periksa kembali";
                                        }
                                        return true;
                                      },
                                    }}
                                    render={({ field }) => (
                                      <TimePicker
                                        {...field}
                                        timeValue={
                                          allFields["days"][index]["slots"]
                                            .length > 0
                                            ? allFields["days"][index][
                                                "slots"
                                              ][0]["last_order"] ||
                                              allFields["days"][index][
                                                "slots"
                                              ][0]["close_time"] ||
                                              ""
                                            : ""
                                        }
                                        handleChange={(e) => {
                                          handleChangeTime(
                                            day?.day,
                                            0,
                                            "last_order",
                                            e.target.value
                                          );
                                        }}
                                      />
                                    )}
                                    defaultValue={
                                      allFields["days"][index]["slots"].length >
                                      0
                                        ? allFields["days"][index]["slots"][0][
                                            "last_order"
                                          ] ||
                                          allFields["days"][index]["slots"][0][
                                            "close_time"
                                          ] ||
                                          ""
                                        : ""
                                    }
                                  />
                                  {errors &&
                                    errors?.days &&
                                    errors?.days[index] &&
                                    errors?.days[index].slots[0] &&
                                    errors?.days[index].slots[0].last_order && (
                                      <span className="d-block font-12 text-danger">
                                        {
                                          errors?.days[index].slots[0]
                                            .last_order?.message
                                        }
                                      </span>
                                    )}
                                </React.Fragment>
                              )}
                            </td>
                            <td>
                              {day?.open_st && (
                                <span
                                  className="text-blue font-bold font-12 cursor-pointer"
                                  onClick={() => handleAddSlot(day?.day)}
                                >
                                  Tambah slot
                                </span>
                              )}
                            </td>
                          </tr>
                          {day?.slots?.length > 1 &&
                            day?.open_st &&
                            day?.slots?.map(
                              (slot, idxSlot) =>
                                idxSlot > 0 && (
                                  <tr key={slot?.key_slot}>
                                    <td className="font-bold text-capitalize"></td>
                                    <td className="font-bold text-capitalize"></td>
                                    <td>
                                      <Controller
                                        name={`days[${index}].slots[${idxSlot}].open_time`}
                                        control={control}
                                        rules={{
                                          required: "Input jam buka",
                                          validate: (open_time) => {
                                            if (
                                              !checkTime(
                                                index,
                                                idxSlot,
                                                "open_time",
                                                open_time
                                              )
                                            ) {
                                              return "Periksa kembali";
                                            }
                                            return true;
                                          },
                                        }}
                                        render={({ field }) => (
                                          <TimePicker
                                            {...field}
                                            timeValue={
                                              allFields["days"][index]["slots"]
                                                .length > 0
                                                ? allFields["days"][index][
                                                    "slots"
                                                  ][idxSlot]["open_time"]
                                                : ""
                                            }
                                            handleChange={(e) => {
                                              handleChangeTime(
                                                day?.day,
                                                idxSlot,
                                                "open_time",
                                                e.target.value
                                              );
                                            }}
                                          />
                                        )}
                                        defaultValue={
                                          allFields["days"][index]["slots"]
                                            .length > 0
                                            ? allFields["days"][index]["slots"][
                                                idxSlot
                                              ]["open_time"]
                                            : ""
                                        }
                                      />
                                      {errors &&
                                        errors?.days &&
                                        errors?.days[index] &&
                                        errors?.days[index].slots[idxSlot] &&
                                        errors?.days[index].slots[idxSlot]
                                          .open_time && (
                                          <span className="d-block font-12 text-danger">
                                            {
                                              errors?.days[index].slots[idxSlot]
                                                .open_time?.message
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Controller
                                        name={`days[${index}].slots[${idxSlot}].close_time`}
                                        control={control}
                                        rules={{
                                          required: "Input jam tutup",
                                          validate: (close_time) => {
                                            if (
                                              !checkTime(
                                                index,
                                                idxSlot,
                                                "close_time",
                                                close_time
                                              )
                                            ) {
                                              return "Periksa kembali";
                                            }
                                            return true;
                                          },
                                        }}
                                        render={({ ...field }) => (
                                          <TimePicker
                                            {...field}
                                            timeValue={
                                              allFields["days"][index]["slots"]
                                                .length > 0
                                                ? allFields["days"][index][
                                                    "slots"
                                                  ][idxSlot]["close_time"]
                                                : ""
                                            }
                                            handleChange={(e) => {
                                              handleChangeTime(
                                                day?.day,
                                                idxSlot,
                                                "close_time",
                                                e.target.value
                                              );
                                            }}
                                          />
                                        )}
                                        defaultValue={
                                          allFields["days"][index]["slots"]
                                            .length > 0
                                            ? allFields["days"][index]["slots"][
                                                idxSlot
                                              ]["close_time"]
                                            : ""
                                        }
                                      />
                                      {errors &&
                                        errors?.days &&
                                        errors?.days[index] &&
                                        errors?.days[index].slots[idxSlot] &&
                                        errors?.days[index].slots[idxSlot]
                                          .close_time && (
                                          <span className="d-block font-12 text-danger">
                                            {
                                              errors?.days[index].slots[idxSlot]
                                                .close_time?.message
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <Controller
                                        name={`days[${index}].slots[${idxSlot}].last_order`}
                                        control={control}
                                        rules={{
                                          validate: (last_order) => {
                                            if (
                                              !checkTime(
                                                index,
                                                idxSlot,
                                                "last_order",
                                                last_order
                                              )
                                            ) {
                                              return "Periksa kembali";
                                            }
                                            return true;
                                          },
                                        }}
                                        render={({ field }) => (
                                          <TimePicker
                                            {...field}
                                            timeValue={
                                              allFields["days"][index]["slots"]
                                                .length > 0
                                                ? allFields["days"][index][
                                                    "slots"
                                                  ][idxSlot]["last_order"] ||
                                                  allFields["days"][index][
                                                    "slots"
                                                  ][idxSlot]["close_time"] ||
                                                  ""
                                                : ""
                                            }
                                            handleChange={(e) => {
                                              handleChangeTime(
                                                day?.day,
                                                idxSlot,
                                                "last_order",
                                                e.target.value
                                              );
                                            }}
                                          />
                                        )}
                                        defaultValue={
                                          allFields["days"][index]["slots"]
                                            .length > 0
                                            ? allFields["days"][index]["slots"][
                                                idxSlot
                                              ]["last_order"] ||
                                              allFields["days"][index]["slots"][
                                                idxSlot
                                              ]["close_time"] ||
                                              ""
                                            : ""
                                        }
                                      />
                                      {errors &&
                                        errors?.days &&
                                        errors?.days[index] &&
                                        errors?.days[index].slots[idxSlot] &&
                                        errors?.days[index].slots[idxSlot]
                                          .last_order && (
                                          <span className="d-block font-12 text-danger">
                                            {
                                              errors?.days[index].slots[idxSlot]
                                                .last_order?.message
                                            }
                                          </span>
                                        )}
                                    </td>
                                    <td>
                                      <span
                                        className="text-blue font-bold font-12 cursor-pointer"
                                        onClick={() =>
                                          handleRemoveSlot(index, idxSlot)
                                        }
                                      >
                                        Hapus slot
                                      </span>
                                    </td>
                                  </tr>
                                )
                            )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="w-100 text-center">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <button
                    type="submit"
                    className="btn btn-blue px-5 py-3"
                    disabled={mutationOperationalHours.isLoading}
                  >
                    SIMPAN
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OperationalTimeForm;
